import type { Serializable } from './Serializable';

/**
 * Backend registration form data.
 */
interface ComRegistrationFormData {
  name: string;
  company: string;
  licenseNumber: string;
  trainingCert: string;
  email: string;
  password: string;
  passwordConfirm: string;
  source?: ComRegistrationSource;
}

export enum ComRegistrationSource {
  ComApp2 = 'ComApp2'
}

/**
 * UI registration form data.
 * Serialized into the backend registration form data.
 * Deserialized from the backend registration form data.
 */
export class ComRegistrationForm implements Serializable<ComRegistrationFormData> {
  name: string = '';
  companyName: string = '';
  companyElectricalLicenseNumber: string = '';
  allumeTrainingCertificationNumber: string = '';
  email: string = '';
  password: string = '';
  confirmPassword: string = '';

  deserialize(data: ComRegistrationFormData): this {
    this.name = data.name;
    this.companyName = data.company;
    this.companyElectricalLicenseNumber = data.licenseNumber;
    this.allumeTrainingCertificationNumber = data.trainingCert;
    this.email = data.email;
    this.password = data.password;
    this.confirmPassword = data.passwordConfirm;
    return this;
  }

  serialize(): ComRegistrationFormData {
    return {
      name: this.name,
      company: this.companyName,
      licenseNumber: this.companyElectricalLicenseNumber,
      trainingCert: this.allumeTrainingCertificationNumber,
      email: this.email,
      password: this.password,
      passwordConfirm: this.confirmPassword,

      /**
       * This ensures that after email validation, the user is redirected back to CommApp2, 
       * allowing them to proceed with logging in.
       * 
       * Note: If this parameter is removed, the user will be redirected to the old commissioning app,
       * as the main server will continue to route them there.
       */
      source: ComRegistrationSource.ComApp2,
    };
  }
}